import React from "react";
/* Bootstrap Components */
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { StyledWrapperPosteos } from "./styled";

const Speakers = (props, { deviceType }) => {
  return (
    <>
      <Row id="posts">
        <StyledWrapperPosteos>
          <Row>
            <Col xs={12} sm={12} md={4} lg={3} xl="2">
              <h1>Notes</h1>
              <hr />
            </Col>
          </Row>
          {props.data.map((el) => (
            <Row style={{ marginTop: "60px" }}>
              <Col lg={7}>
                <div>
                  <div class="embed-responsive embed-responsive-21by9">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/BMlE8M2ktkk"
                      allowfullscreen
                      style={{
                        width: "-webkit-fill-available",
                        height: "500px",
                      }}
                    ></iframe>
                  </div>
                </div>
              </Col>
              <Col
                lg={5}
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <a
                  href="https://chequeado.com/junto-a-100-chequeadores-y-especialistas-de-la-region-realizamos-el-gran-encuentro-del-fact-checking-de-latinoamerica/"
                  target="_blank"
                >
                  <div>
                    <h3>{el.titulo_en}</h3>
                    <p className="description">{el.descripcion_en}</p>
                  </div>
                </a>
              </Col>
            </Row>
          ))}
        </StyledWrapperPosteos>
      </Row>
    </>
  );
};

export default Speakers;
